import React from "react";
import { PersonFill } from "react-bootstrap-icons";

const ExperienceCard = ({ title, company, date, iconFillColor }) => {
  const glowCardStyle = {
    height: "auto",
    cursor: "pointer",
    border: "1px solid #2a2e5a",
    transition: "all 0.3s",
    position: "relative",
    backgroundColor: "#101123",
    color: "#e1e1e6",
    borderRadius: "1rem",
    boxShadow: `0 0 20px rgba(86, 76, 225, 0.5)`,
    width: "100%",
    "&:hover": {
      borderColor: "#564ce1",
    },
  };

  const dateStyle = {
    fontSize: "1rem",
    color: "#16f2b3",
    textAlign: "center",
    display: "flex",
    justifyContent: "center",
  };

  const flexContainerStyle = {
    display: "flex",
    alignItems: "center",
    gap: "2rem",
    paddingLeft: "12px",
    paddingRight: "12px",
  };

  const iconStyle = {
    color: "#564ce1",
    transition: "all 0.3s",
  };

  const titleStyle = {
    fontSize: "1.5rem",
    fontWeight: "500",
    textTransform: "uppercase",
    marginBottom: "8px",
  };

  const companyStyle = {
    fontSize: "0.975rem",
  };

  return (
    <article style={glowCardStyle}>
      <div
        style={{
          padding: "12px",
          position: "relative",
        }}
      >
        <div style={dateStyle}>
          <p>{date}</p>
        </div>
        <div style={flexContainerStyle}>
          <PersonFill size={45} style={iconStyle} />

          <div>
            <p style={titleStyle}>{title}</p>
            <p style={companyStyle}>{company}</p>
          </div>
        </div>
      </div>
    </article>
  );
};

export default ExperienceCard;

export const SkillCard = ({ icon, text }) => {
  const glowCardStyle = {
    height: "128px",
    cursor: "pointer",
    border: "1px solid #2a2e5a",
    transition: "all 0.3s",
    position: "relative",
    backgroundColor: "#101123",
    color: "#e1e1e6",
    borderRadius: "1rem",
    width: "100%",
    maxWidth: "157px",
    minWidth: "147px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "1rem",
    "&:hover": {
      borderColor: "#564ce1",
    },
  };

  return (
    <article style={glowCardStyle}>
      <img
        src={icon}
        alt="skill icon"
        style={{ width: "50px", height: "50px", marginBottom: "1rem" }}
      />
      <p
        style={{ fontSize: "1.1rem", fontWeight: "bold", textAlign: "center" }}
      >
        {text}
      </p>
    </article>
  );
};
